// source: PushDataV3ApiWrapper.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var PublicDealsV3Api_pb = require('./PublicDealsV3Api_pb.js');
goog.object.extend(proto, PublicDealsV3Api_pb);
var PublicIncreaseDepthsV3Api_pb = require('./PublicIncreaseDepthsV3Api_pb.js');
goog.object.extend(proto, PublicIncreaseDepthsV3Api_pb);
var PublicLimitDepthsV3Api_pb = require('./PublicLimitDepthsV3Api_pb.js');
goog.object.extend(proto, PublicLimitDepthsV3Api_pb);
var PrivateOrdersV3Api_pb = require('./PrivateOrdersV3Api_pb.js');
goog.object.extend(proto, PrivateOrdersV3Api_pb);
var PublicBookTickerV3Api_pb = require('./PublicBookTickerV3Api_pb.js');
goog.object.extend(proto, PublicBookTickerV3Api_pb);
var PrivateDealsV3Api_pb = require('./PrivateDealsV3Api_pb.js');
goog.object.extend(proto, PrivateDealsV3Api_pb);
var PrivateAccountV3Api_pb = require('./PrivateAccountV3Api_pb.js');
goog.object.extend(proto, PrivateAccountV3Api_pb);
var PublicSpotKlineV3Api_pb = require('./PublicSpotKlineV3Api_pb.js');
goog.object.extend(proto, PublicSpotKlineV3Api_pb);
var PublicMiniTickerV3Api_pb = require('./PublicMiniTickerV3Api_pb.js');
goog.object.extend(proto, PublicMiniTickerV3Api_pb);
var PublicMiniTickersV3Api_pb = require('./PublicMiniTickersV3Api_pb.js');
goog.object.extend(proto, PublicMiniTickersV3Api_pb);
var PublicBookTickerBatchV3Api_pb = require('./PublicBookTickerBatchV3Api_pb.js');
goog.object.extend(proto, PublicBookTickerBatchV3Api_pb);
var PublicIncreaseDepthsBatchV3Api_pb = require('./PublicIncreaseDepthsBatchV3Api_pb.js');
goog.object.extend(proto, PublicIncreaseDepthsBatchV3Api_pb);
var PublicAggreDepthsV3Api_pb = require('./PublicAggreDepthsV3Api_pb.js');
goog.object.extend(proto, PublicAggreDepthsV3Api_pb);
var PublicAggreDealsV3Api_pb = require('./PublicAggreDealsV3Api_pb.js');
goog.object.extend(proto, PublicAggreDealsV3Api_pb);
var PublicAggreBookTickerV3Api_pb = require('./PublicAggreBookTickerV3Api_pb.js');
goog.object.extend(proto, PublicAggreBookTickerV3Api_pb);
goog.exportSymbol('proto.PushDataV3ApiWrapper', null, global);
goog.exportSymbol('proto.PushDataV3ApiWrapper.BodyCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.PushDataV3ApiWrapper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.PushDataV3ApiWrapper.oneofGroups_);
};
goog.inherits(proto.PushDataV3ApiWrapper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.PushDataV3ApiWrapper.displayName = 'proto.PushDataV3ApiWrapper';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.PushDataV3ApiWrapper.oneofGroups_ = [[301,302,303,304,305,306,307,308,309,310,311,312,313,314,315]];

/**
 * @enum {number}
 */
proto.PushDataV3ApiWrapper.BodyCase = {
  BODY_NOT_SET: 0,
  PUBLICDEALS: 301,
  PUBLICINCREASEDEPTHS: 302,
  PUBLICLIMITDEPTHS: 303,
  PRIVATEORDERS: 304,
  PUBLICBOOKTICKER: 305,
  PRIVATEDEALS: 306,
  PRIVATEACCOUNT: 307,
  PUBLICSPOTKLINE: 308,
  PUBLICMINITICKER: 309,
  PUBLICMINITICKERS: 310,
  PUBLICBOOKTICKERBATCH: 311,
  PUBLICINCREASEDEPTHSBATCH: 312,
  PUBLICAGGREDEPTHS: 313,
  PUBLICAGGREDEALS: 314,
  PUBLICAGGREBOOKTICKER: 315
};

/**
 * @return {proto.PushDataV3ApiWrapper.BodyCase}
 */
proto.PushDataV3ApiWrapper.prototype.getBodyCase = function() {
  return /** @type {proto.PushDataV3ApiWrapper.BodyCase} */(jspb.Message.computeOneofCase(this, proto.PushDataV3ApiWrapper.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.PushDataV3ApiWrapper.prototype.toObject = function(opt_includeInstance) {
  return proto.PushDataV3ApiWrapper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PushDataV3ApiWrapper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PushDataV3ApiWrapper.toObject = function(includeInstance, msg) {
  var f, obj = {
channel: jspb.Message.getFieldWithDefault(msg, 1, ""),
publicdeals: (f = msg.getPublicdeals()) && PublicDealsV3Api_pb.PublicDealsV3Api.toObject(includeInstance, f),
publicincreasedepths: (f = msg.getPublicincreasedepths()) && PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api.toObject(includeInstance, f),
publiclimitdepths: (f = msg.getPubliclimitdepths()) && PublicLimitDepthsV3Api_pb.PublicLimitDepthsV3Api.toObject(includeInstance, f),
privateorders: (f = msg.getPrivateorders()) && PrivateOrdersV3Api_pb.PrivateOrdersV3Api.toObject(includeInstance, f),
publicbookticker: (f = msg.getPublicbookticker()) && PublicBookTickerV3Api_pb.PublicBookTickerV3Api.toObject(includeInstance, f),
privatedeals: (f = msg.getPrivatedeals()) && PrivateDealsV3Api_pb.PrivateDealsV3Api.toObject(includeInstance, f),
privateaccount: (f = msg.getPrivateaccount()) && PrivateAccountV3Api_pb.PrivateAccountV3Api.toObject(includeInstance, f),
publicspotkline: (f = msg.getPublicspotkline()) && PublicSpotKlineV3Api_pb.PublicSpotKlineV3Api.toObject(includeInstance, f),
publicminiticker: (f = msg.getPublicminiticker()) && PublicMiniTickerV3Api_pb.PublicMiniTickerV3Api.toObject(includeInstance, f),
publicminitickers: (f = msg.getPublicminitickers()) && PublicMiniTickersV3Api_pb.PublicMiniTickersV3Api.toObject(includeInstance, f),
publicbooktickerbatch: (f = msg.getPublicbooktickerbatch()) && PublicBookTickerBatchV3Api_pb.PublicBookTickerBatchV3Api.toObject(includeInstance, f),
publicincreasedepthsbatch: (f = msg.getPublicincreasedepthsbatch()) && PublicIncreaseDepthsBatchV3Api_pb.PublicIncreaseDepthsBatchV3Api.toObject(includeInstance, f),
publicaggredepths: (f = msg.getPublicaggredepths()) && PublicAggreDepthsV3Api_pb.PublicAggreDepthsV3Api.toObject(includeInstance, f),
publicaggredeals: (f = msg.getPublicaggredeals()) && PublicAggreDealsV3Api_pb.PublicAggreDealsV3Api.toObject(includeInstance, f),
publicaggrebookticker: (f = msg.getPublicaggrebookticker()) && PublicAggreBookTickerV3Api_pb.PublicAggreBookTickerV3Api.toObject(includeInstance, f),
symbol: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
symbolid: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
createtime: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
sendtime: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PushDataV3ApiWrapper}
 */
proto.PushDataV3ApiWrapper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.PushDataV3ApiWrapper;
  return proto.PushDataV3ApiWrapper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PushDataV3ApiWrapper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PushDataV3ApiWrapper}
 */
proto.PushDataV3ApiWrapper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setChannel(value);
      break;
    case 301:
      var value = new PublicDealsV3Api_pb.PublicDealsV3Api;
      reader.readMessage(value,PublicDealsV3Api_pb.PublicDealsV3Api.deserializeBinaryFromReader);
      msg.setPublicdeals(value);
      break;
    case 302:
      var value = new PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api;
      reader.readMessage(value,PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api.deserializeBinaryFromReader);
      msg.setPublicincreasedepths(value);
      break;
    case 303:
      var value = new PublicLimitDepthsV3Api_pb.PublicLimitDepthsV3Api;
      reader.readMessage(value,PublicLimitDepthsV3Api_pb.PublicLimitDepthsV3Api.deserializeBinaryFromReader);
      msg.setPubliclimitdepths(value);
      break;
    case 304:
      var value = new PrivateOrdersV3Api_pb.PrivateOrdersV3Api;
      reader.readMessage(value,PrivateOrdersV3Api_pb.PrivateOrdersV3Api.deserializeBinaryFromReader);
      msg.setPrivateorders(value);
      break;
    case 305:
      var value = new PublicBookTickerV3Api_pb.PublicBookTickerV3Api;
      reader.readMessage(value,PublicBookTickerV3Api_pb.PublicBookTickerV3Api.deserializeBinaryFromReader);
      msg.setPublicbookticker(value);
      break;
    case 306:
      var value = new PrivateDealsV3Api_pb.PrivateDealsV3Api;
      reader.readMessage(value,PrivateDealsV3Api_pb.PrivateDealsV3Api.deserializeBinaryFromReader);
      msg.setPrivatedeals(value);
      break;
    case 307:
      var value = new PrivateAccountV3Api_pb.PrivateAccountV3Api;
      reader.readMessage(value,PrivateAccountV3Api_pb.PrivateAccountV3Api.deserializeBinaryFromReader);
      msg.setPrivateaccount(value);
      break;
    case 308:
      var value = new PublicSpotKlineV3Api_pb.PublicSpotKlineV3Api;
      reader.readMessage(value,PublicSpotKlineV3Api_pb.PublicSpotKlineV3Api.deserializeBinaryFromReader);
      msg.setPublicspotkline(value);
      break;
    case 309:
      var value = new PublicMiniTickerV3Api_pb.PublicMiniTickerV3Api;
      reader.readMessage(value,PublicMiniTickerV3Api_pb.PublicMiniTickerV3Api.deserializeBinaryFromReader);
      msg.setPublicminiticker(value);
      break;
    case 310:
      var value = new PublicMiniTickersV3Api_pb.PublicMiniTickersV3Api;
      reader.readMessage(value,PublicMiniTickersV3Api_pb.PublicMiniTickersV3Api.deserializeBinaryFromReader);
      msg.setPublicminitickers(value);
      break;
    case 311:
      var value = new PublicBookTickerBatchV3Api_pb.PublicBookTickerBatchV3Api;
      reader.readMessage(value,PublicBookTickerBatchV3Api_pb.PublicBookTickerBatchV3Api.deserializeBinaryFromReader);
      msg.setPublicbooktickerbatch(value);
      break;
    case 312:
      var value = new PublicIncreaseDepthsBatchV3Api_pb.PublicIncreaseDepthsBatchV3Api;
      reader.readMessage(value,PublicIncreaseDepthsBatchV3Api_pb.PublicIncreaseDepthsBatchV3Api.deserializeBinaryFromReader);
      msg.setPublicincreasedepthsbatch(value);
      break;
    case 313:
      var value = new PublicAggreDepthsV3Api_pb.PublicAggreDepthsV3Api;
      reader.readMessage(value,PublicAggreDepthsV3Api_pb.PublicAggreDepthsV3Api.deserializeBinaryFromReader);
      msg.setPublicaggredepths(value);
      break;
    case 314:
      var value = new PublicAggreDealsV3Api_pb.PublicAggreDealsV3Api;
      reader.readMessage(value,PublicAggreDealsV3Api_pb.PublicAggreDealsV3Api.deserializeBinaryFromReader);
      msg.setPublicaggredeals(value);
      break;
    case 315:
      var value = new PublicAggreBookTickerV3Api_pb.PublicAggreBookTickerV3Api;
      reader.readMessage(value,PublicAggreBookTickerV3Api_pb.PublicAggreBookTickerV3Api.deserializeBinaryFromReader);
      msg.setPublicaggrebookticker(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSymbolid(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatetime(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSendtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.PushDataV3ApiWrapper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.PushDataV3ApiWrapper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PushDataV3ApiWrapper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.PushDataV3ApiWrapper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannel();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPublicdeals();
  if (f != null) {
    writer.writeMessage(
      301,
      f,
      PublicDealsV3Api_pb.PublicDealsV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicincreasedepths();
  if (f != null) {
    writer.writeMessage(
      302,
      f,
      PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPubliclimitdepths();
  if (f != null) {
    writer.writeMessage(
      303,
      f,
      PublicLimitDepthsV3Api_pb.PublicLimitDepthsV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPrivateorders();
  if (f != null) {
    writer.writeMessage(
      304,
      f,
      PrivateOrdersV3Api_pb.PrivateOrdersV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicbookticker();
  if (f != null) {
    writer.writeMessage(
      305,
      f,
      PublicBookTickerV3Api_pb.PublicBookTickerV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPrivatedeals();
  if (f != null) {
    writer.writeMessage(
      306,
      f,
      PrivateDealsV3Api_pb.PrivateDealsV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPrivateaccount();
  if (f != null) {
    writer.writeMessage(
      307,
      f,
      PrivateAccountV3Api_pb.PrivateAccountV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicspotkline();
  if (f != null) {
    writer.writeMessage(
      308,
      f,
      PublicSpotKlineV3Api_pb.PublicSpotKlineV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicminiticker();
  if (f != null) {
    writer.writeMessage(
      309,
      f,
      PublicMiniTickerV3Api_pb.PublicMiniTickerV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicminitickers();
  if (f != null) {
    writer.writeMessage(
      310,
      f,
      PublicMiniTickersV3Api_pb.PublicMiniTickersV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicbooktickerbatch();
  if (f != null) {
    writer.writeMessage(
      311,
      f,
      PublicBookTickerBatchV3Api_pb.PublicBookTickerBatchV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicincreasedepthsbatch();
  if (f != null) {
    writer.writeMessage(
      312,
      f,
      PublicIncreaseDepthsBatchV3Api_pb.PublicIncreaseDepthsBatchV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicaggredepths();
  if (f != null) {
    writer.writeMessage(
      313,
      f,
      PublicAggreDepthsV3Api_pb.PublicAggreDepthsV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicaggredeals();
  if (f != null) {
    writer.writeMessage(
      314,
      f,
      PublicAggreDealsV3Api_pb.PublicAggreDealsV3Api.serializeBinaryToWriter
    );
  }
  f = message.getPublicaggrebookticker();
  if (f != null) {
    writer.writeMessage(
      315,
      f,
      PublicAggreBookTickerV3Api_pb.PublicAggreBookTickerV3Api.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string channel = 1;
 * @return {string}
 */
proto.PushDataV3ApiWrapper.prototype.getChannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.setChannel = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PublicDealsV3Api publicDeals = 301;
 * @return {?proto.PublicDealsV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicdeals = function() {
  return /** @type{?proto.PublicDealsV3Api} */ (
    jspb.Message.getWrapperField(this, PublicDealsV3Api_pb.PublicDealsV3Api, 301));
};


/**
 * @param {?proto.PublicDealsV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicdeals = function(value) {
  return jspb.Message.setOneofWrapperField(this, 301, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicdeals = function() {
  return this.setPublicdeals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicdeals = function() {
  return jspb.Message.getField(this, 301) != null;
};


/**
 * optional PublicIncreaseDepthsV3Api publicIncreaseDepths = 302;
 * @return {?proto.PublicIncreaseDepthsV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicincreasedepths = function() {
  return /** @type{?proto.PublicIncreaseDepthsV3Api} */ (
    jspb.Message.getWrapperField(this, PublicIncreaseDepthsV3Api_pb.PublicIncreaseDepthsV3Api, 302));
};


/**
 * @param {?proto.PublicIncreaseDepthsV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicincreasedepths = function(value) {
  return jspb.Message.setOneofWrapperField(this, 302, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicincreasedepths = function() {
  return this.setPublicincreasedepths(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicincreasedepths = function() {
  return jspb.Message.getField(this, 302) != null;
};


/**
 * optional PublicLimitDepthsV3Api publicLimitDepths = 303;
 * @return {?proto.PublicLimitDepthsV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPubliclimitdepths = function() {
  return /** @type{?proto.PublicLimitDepthsV3Api} */ (
    jspb.Message.getWrapperField(this, PublicLimitDepthsV3Api_pb.PublicLimitDepthsV3Api, 303));
};


/**
 * @param {?proto.PublicLimitDepthsV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPubliclimitdepths = function(value) {
  return jspb.Message.setOneofWrapperField(this, 303, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPubliclimitdepths = function() {
  return this.setPubliclimitdepths(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPubliclimitdepths = function() {
  return jspb.Message.getField(this, 303) != null;
};


/**
 * optional PrivateOrdersV3Api privateOrders = 304;
 * @return {?proto.PrivateOrdersV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPrivateorders = function() {
  return /** @type{?proto.PrivateOrdersV3Api} */ (
    jspb.Message.getWrapperField(this, PrivateOrdersV3Api_pb.PrivateOrdersV3Api, 304));
};


/**
 * @param {?proto.PrivateOrdersV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPrivateorders = function(value) {
  return jspb.Message.setOneofWrapperField(this, 304, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPrivateorders = function() {
  return this.setPrivateorders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPrivateorders = function() {
  return jspb.Message.getField(this, 304) != null;
};


/**
 * optional PublicBookTickerV3Api publicBookTicker = 305;
 * @return {?proto.PublicBookTickerV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicbookticker = function() {
  return /** @type{?proto.PublicBookTickerV3Api} */ (
    jspb.Message.getWrapperField(this, PublicBookTickerV3Api_pb.PublicBookTickerV3Api, 305));
};


/**
 * @param {?proto.PublicBookTickerV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicbookticker = function(value) {
  return jspb.Message.setOneofWrapperField(this, 305, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicbookticker = function() {
  return this.setPublicbookticker(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicbookticker = function() {
  return jspb.Message.getField(this, 305) != null;
};


/**
 * optional PrivateDealsV3Api privateDeals = 306;
 * @return {?proto.PrivateDealsV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPrivatedeals = function() {
  return /** @type{?proto.PrivateDealsV3Api} */ (
    jspb.Message.getWrapperField(this, PrivateDealsV3Api_pb.PrivateDealsV3Api, 306));
};


/**
 * @param {?proto.PrivateDealsV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPrivatedeals = function(value) {
  return jspb.Message.setOneofWrapperField(this, 306, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPrivatedeals = function() {
  return this.setPrivatedeals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPrivatedeals = function() {
  return jspb.Message.getField(this, 306) != null;
};


/**
 * optional PrivateAccountV3Api privateAccount = 307;
 * @return {?proto.PrivateAccountV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPrivateaccount = function() {
  return /** @type{?proto.PrivateAccountV3Api} */ (
    jspb.Message.getWrapperField(this, PrivateAccountV3Api_pb.PrivateAccountV3Api, 307));
};


/**
 * @param {?proto.PrivateAccountV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPrivateaccount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 307, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPrivateaccount = function() {
  return this.setPrivateaccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPrivateaccount = function() {
  return jspb.Message.getField(this, 307) != null;
};


/**
 * optional PublicSpotKlineV3Api publicSpotKline = 308;
 * @return {?proto.PublicSpotKlineV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicspotkline = function() {
  return /** @type{?proto.PublicSpotKlineV3Api} */ (
    jspb.Message.getWrapperField(this, PublicSpotKlineV3Api_pb.PublicSpotKlineV3Api, 308));
};


/**
 * @param {?proto.PublicSpotKlineV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicspotkline = function(value) {
  return jspb.Message.setOneofWrapperField(this, 308, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicspotkline = function() {
  return this.setPublicspotkline(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicspotkline = function() {
  return jspb.Message.getField(this, 308) != null;
};


/**
 * optional PublicMiniTickerV3Api publicMiniTicker = 309;
 * @return {?proto.PublicMiniTickerV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicminiticker = function() {
  return /** @type{?proto.PublicMiniTickerV3Api} */ (
    jspb.Message.getWrapperField(this, PublicMiniTickerV3Api_pb.PublicMiniTickerV3Api, 309));
};


/**
 * @param {?proto.PublicMiniTickerV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicminiticker = function(value) {
  return jspb.Message.setOneofWrapperField(this, 309, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicminiticker = function() {
  return this.setPublicminiticker(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicminiticker = function() {
  return jspb.Message.getField(this, 309) != null;
};


/**
 * optional PublicMiniTickersV3Api publicMiniTickers = 310;
 * @return {?proto.PublicMiniTickersV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicminitickers = function() {
  return /** @type{?proto.PublicMiniTickersV3Api} */ (
    jspb.Message.getWrapperField(this, PublicMiniTickersV3Api_pb.PublicMiniTickersV3Api, 310));
};


/**
 * @param {?proto.PublicMiniTickersV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicminitickers = function(value) {
  return jspb.Message.setOneofWrapperField(this, 310, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicminitickers = function() {
  return this.setPublicminitickers(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicminitickers = function() {
  return jspb.Message.getField(this, 310) != null;
};


/**
 * optional PublicBookTickerBatchV3Api publicBookTickerBatch = 311;
 * @return {?proto.PublicBookTickerBatchV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicbooktickerbatch = function() {
  return /** @type{?proto.PublicBookTickerBatchV3Api} */ (
    jspb.Message.getWrapperField(this, PublicBookTickerBatchV3Api_pb.PublicBookTickerBatchV3Api, 311));
};


/**
 * @param {?proto.PublicBookTickerBatchV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicbooktickerbatch = function(value) {
  return jspb.Message.setOneofWrapperField(this, 311, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicbooktickerbatch = function() {
  return this.setPublicbooktickerbatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicbooktickerbatch = function() {
  return jspb.Message.getField(this, 311) != null;
};


/**
 * optional PublicIncreaseDepthsBatchV3Api publicIncreaseDepthsBatch = 312;
 * @return {?proto.PublicIncreaseDepthsBatchV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicincreasedepthsbatch = function() {
  return /** @type{?proto.PublicIncreaseDepthsBatchV3Api} */ (
    jspb.Message.getWrapperField(this, PublicIncreaseDepthsBatchV3Api_pb.PublicIncreaseDepthsBatchV3Api, 312));
};


/**
 * @param {?proto.PublicIncreaseDepthsBatchV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicincreasedepthsbatch = function(value) {
  return jspb.Message.setOneofWrapperField(this, 312, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicincreasedepthsbatch = function() {
  return this.setPublicincreasedepthsbatch(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicincreasedepthsbatch = function() {
  return jspb.Message.getField(this, 312) != null;
};


/**
 * optional PublicAggreDepthsV3Api publicAggreDepths = 313;
 * @return {?proto.PublicAggreDepthsV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicaggredepths = function() {
  return /** @type{?proto.PublicAggreDepthsV3Api} */ (
    jspb.Message.getWrapperField(this, PublicAggreDepthsV3Api_pb.PublicAggreDepthsV3Api, 313));
};


/**
 * @param {?proto.PublicAggreDepthsV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicaggredepths = function(value) {
  return jspb.Message.setOneofWrapperField(this, 313, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicaggredepths = function() {
  return this.setPublicaggredepths(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicaggredepths = function() {
  return jspb.Message.getField(this, 313) != null;
};


/**
 * optional PublicAggreDealsV3Api publicAggreDeals = 314;
 * @return {?proto.PublicAggreDealsV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicaggredeals = function() {
  return /** @type{?proto.PublicAggreDealsV3Api} */ (
    jspb.Message.getWrapperField(this, PublicAggreDealsV3Api_pb.PublicAggreDealsV3Api, 314));
};


/**
 * @param {?proto.PublicAggreDealsV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicaggredeals = function(value) {
  return jspb.Message.setOneofWrapperField(this, 314, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicaggredeals = function() {
  return this.setPublicaggredeals(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicaggredeals = function() {
  return jspb.Message.getField(this, 314) != null;
};


/**
 * optional PublicAggreBookTickerV3Api publicAggreBookTicker = 315;
 * @return {?proto.PublicAggreBookTickerV3Api}
 */
proto.PushDataV3ApiWrapper.prototype.getPublicaggrebookticker = function() {
  return /** @type{?proto.PublicAggreBookTickerV3Api} */ (
    jspb.Message.getWrapperField(this, PublicAggreBookTickerV3Api_pb.PublicAggreBookTickerV3Api, 315));
};


/**
 * @param {?proto.PublicAggreBookTickerV3Api|undefined} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
*/
proto.PushDataV3ApiWrapper.prototype.setPublicaggrebookticker = function(value) {
  return jspb.Message.setOneofWrapperField(this, 315, proto.PushDataV3ApiWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearPublicaggrebookticker = function() {
  return this.setPublicaggrebookticker(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasPublicaggrebookticker = function() {
  return jspb.Message.getField(this, 315) != null;
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.PushDataV3ApiWrapper.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.setSymbol = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearSymbol = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasSymbol = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string symbolId = 4;
 * @return {string}
 */
proto.PushDataV3ApiWrapper.prototype.getSymbolid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.setSymbolid = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearSymbolid = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasSymbolid = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 createTime = 5;
 * @return {number}
 */
proto.PushDataV3ApiWrapper.prototype.getCreatetime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.setCreatetime = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearCreatetime = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasCreatetime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 sendTime = 6;
 * @return {number}
 */
proto.PushDataV3ApiWrapper.prototype.getSendtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.setSendtime = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.PushDataV3ApiWrapper} returns this
 */
proto.PushDataV3ApiWrapper.prototype.clearSendtime = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.PushDataV3ApiWrapper.prototype.hasSendtime = function() {
  return jspb.Message.getField(this, 6) != null;
};


goog.object.extend(exports, proto);
